import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: theme => css`
    iframe {
      border-radius: ${theme.border.radius.md};
    }
  `,
  containerWrapper: css`
    flex: 0 0 auto;
    width: 100%;
  `,
  meetingHeader: ({ colors, border, spacing }) => css`
    flex: 0 0 auto;
    width: 100%;

    ul {
      display: flex;
      gap: ${spacing.sm};
      margin: ${spacing.xxs} 0 ${spacing.xs};

      li {
        display: inline-flex;
        align-items: center;

        &::before {
          content: '';
          display: inline-flex;
          width: ${spacing.xxs};
          height: ${spacing.xxs};
          margin-right: ${spacing.xxs};
          border-radius: ${border.radius.full};
          background-color: ${colors.brand.primary[300]};
        }
      }
    }
  `,

  chatWrapper: () => css`
    > div {
      height: 100%;
      max-height: 550px;
    }
  `,
})

export { useStyles }
